import React from "react";

import OrderHistoryCard from "../orderHistoryCard/OrderHistoryCard";
import { Order } from "@/types/AppTypes";
const OrderHistoryCompo = ({ orders, handlePickUpOptions }: { orders: Order[]; handlePickUpOptions: (data: { orderId: string; deliveryMethod: string; storeLocation?: string }) => void; }) => {
  return (
    <div className="space-y-6">
    {orders?.map(order => (
      <OrderHistoryCard
        key={order.id}
        orderHistory={order}
        handlePickUpOptions={handlePickUpOptions}
      />
    ))}
    </div>
  );
};

export default OrderHistoryCompo;
